/*
	VIEWS: TV Episode
		
	- This isn't nearly as complicated as Radio (see show_radio.js).
	It only gets split out into its own file to prevent confusion due to Radio being its own file.
	
	
	Standard View use except you need to pass in both episode model and show data as an attribute.
	
	APP.getView().showChildView('mainRegion', Backbone.Radio.channel('views').request('show-tv-episode',{
		 model : episodeData
		,attributes:{ program:showData }
	}) )	
*/

Backbone.Radio.channel("views").reply('show-tv-episode', function(options){

	    
    var collectionsView = Mn.View.extend({
         template: _.template('<div class="collections"><h2 class="font-normal collection"></h2><div class="collectionsEps row"></div></div>')
		,onAttach: function(){
			var showSlug = this.model.attributes.slug;
			var currentEpisodeId = this.attributes.episodeid
			this.$el.find('h2').append(this.model.attributes.title+" Collection")
            var $target = this.$el.find('.collectionsEps')
            var hasNew = false;
            $target.empty();
            var sorted = _.sortBy(this.model.attributes.episodes,function(e){ return +e.ordinal; })
            _.each(sorted,function(ep){
                ep.isCollection = true;	
                // Gets Season# for collections episodes 					
				$.when( Backbone.Radio.channel('entities').request('season',{id:ep.seasonid}) ).done(function(data){ 
					var sOrdinal = data.attributes.ordinal // Season Ordinal 
			        ep.sOrdinal = sOrdinal	
	                var results = getEpisodeHTML(ep,showSlug,currentEpisodeId);
                    $target.append(results.htm)
                    if(results.hasNew){ hasNew=true; }							
				})
            })
            
            if(hasNew){
                this.$el.find('h2').append(" <span class='new'>NEW</span>")
            }		
		}

    });
	
	// The Page
	var tvEpisodeView = Mn.View.extend({
		model: options.model
		,attributes: options.attributes
		,template: _.template("</div><div id='episodePlaying'></div><div id='episodeCollection'></div><div id='allEpisodes'></div>")
		,regions: {
			episodePlaying: {
				el: '#episodePlaying'
			}
			,allEpisodes: {
				el: "#allEpisodes"
			}
			,episodeCollection: {
				el: "#episodeCollection"
			}
		}
		,onRender: function(){
			var that = this;
			var slug = this.attributes.slug;
			
			// child View for playing
			this.showChildView('episodePlaying', new playingEpisodeView({ model: this.model, attributes: this.attributes}));	
			
	        // pov, nova, great-performances,antiques-roadshow,american-masters are only shows that have collections for NOW
	        // this will call Collection API only when shows are above listed shows 
	        if (slug==="pov" || slug==="nova" || slug==="great-performances" || slug==="antiques-roadshow" || slug==="american-masters")			{
	        // We want to display Collection episodes of the specific(playing) episode so need to call all collections episode and check episoe we are on vs 
	        // collections episode
			  	$.when( Backbone.Radio.channel('entities').request('collections', {showId:that.model.attributes.showid}) ).done(function(data){
				  	_.map(data.models, function(each){
					  	// gets all episodes of a collection
					  	$.when( Backbone.Radio.channel('entities').request('collection', {id:each.attributes.id,incEpisodes:true})).done(function(mData){
						  	// Check episode we are playing vs collection episodes 
						  	_.map(mData.attributes.episodes, function(eachEpisode){
							  	if(that.model.attributes.id == eachEpisode.id) {
								  	that.showChildView('episodeCollection', new collectionsView({ model:mData,attributes: that.attributes }))
								}
						  	})
					  	})
					})
	            })
	        }     		
            
			// Child View for displaying all episodes 
			if(this.model.attributes.seasonid){
				this.attributes.episodeid = this.model.attributes.id;
				$.when( Backbone.Radio.channel('entities').request('season',{id:this.model.attributes.seasonid,incEpisodes:true}) ).done(function(data){
				 	that.showChildView('allEpisodes', new allEpisodes({ model: data, attributes: that.attributes}))			 
				})
			} 
		}	
	});
	
	// Child View for All episodes 
	var allEpisodes = Mn.View.extend({
		template: _.template("<div class='seasons'><h2 class='font-normal'>Season <%-ordinal%></h2><div class='seasonEps row'></div></div>")
		,onAttach: function(){
			var currentEpisodeId = this.attributes.episodeid
			var that = this; 
			var showSlug = this.attributes.program.attributes.slug;			
			var $target = that.$el.find('.seasonEps')
            var hasNew = false;
            $target.empty(); 
            var sorted = _.sortBy(this.model.attributes.episodes,function(e){ return +e.ordinal; })
            _.each(sorted,function(ep){
                var results = getEpisodeHTML(ep,showSlug, currentEpisodeId);
                $target.append(results.htm)
                if(results.hasNew){ hasNew=true; }
            })
            if(hasNew){
                that.$el.find('h2').append(" <span class='new'>NEW</span>")
            }		
		}	
	});
	
	function getEpisodeHTML(ep,showSlug,currentEpisodeId){
		var hasNew = false; 
		var htm = "";
			
		var img = Backbone.Radio.channel('utilities').request('image-parse',{
	             json:ep.images
	            ,desiredProfile:"asset-mezzanine-16x9"
	        });
	    
	    if(!img){
		    //kids programming uses a different asset profile because of course they do
		    img = Backbone.Radio.channel('utilities').request('image-parse',{ json:ep.images, desiredProfile:"asset-kids-mezzanine1-16x9" });
	    }
	   
		if(showSlug==="curate" || showSlug==="curate-u" || showSlug==="curate-757"){ // PT#150304957
	        htm += "<div class='col-md-4 col-sm-6 pb8 font-light'>";
	    }else {
		    htm += "<div class='col-lg-3 col-md-4 col-sm-6 pb8 font-light'>"
	    }
		
		htm += "<a href='/program/"+showSlug+"/e/"+ep.slug+"'>";
		
		if(currentEpisodeId===ep.id) { htm += "<div class='nowPlayingDiv'>"}


		if(img){ 
			if(currentEpisodeId===ep.id){
				 htm += "<img alt='' src='"+img+".crop.352x198.jpg' class='playing'/>"; 
			} else {
				 htm += "<img alt='' src='"+img+".crop.352x198.jpg'/>";
			}
            if(ep.status=="passport_exclusive"){ htm += "<img alt='' class='img_passport' src='/assets/imgs/cornerFlag.svg' />"; }
        }

        if(currentEpisodeId===ep.id) { htm += "<div class='textDiv'><h3 class='nowPlayingText'>NOW SHOWING</h3></div></div>" }
        
        // PT: #177608054, Adding sm to GreenBeats 
        var ep_title; 
        if(showSlug == "greenbeats"){
            ep_title = ep.title.replace("Greenbeat", "Greenbeat&#8480;");
        } else { ep_title = ep.title}
	    
        
        htm += "<h3 class='font-normal mt4 mb0'>"+ ep_title;
            if(ep.availability){ //should always exist, but don't risk json.parse exploding
                var availability = Backbone.Radio.channel('utilities').request('availability-parse',ep.availability)
					if(ep.status==="passport_exclusive"){
						if(availability.passport.newToday){
							htm += " <span class='new'>NEW&nbsp;TODAY</span>";
							hasNew=true;
						}else if(availability.passport.newThisWeek){
							htm += " <span class='new'>NEW</span>";
							hasNew=true;
						}
					}else{ //public
						if(availability.public.newToday){
							htm += " <span class='new'>NEW&nbsp;TODAY</span>";
							hasNew=true;
						}else if(availability.public.newThisWeek){
							htm += " <span class='new'>NEW</span>";
							hasNew=true;
						}
					}	
			}
					htm += "</h3>"
					htm += "</a>"
        	
        if(ep.atype=='preview' || (("Episode "+ep.ordinal) !== ep_title)){ //we just dont' want to show Episode 1 / Episode 1
            if(!ep.isCollection){
	            htm += "<p class='m0'>"+((ep.atype=='preview')?"Preview":"Episode "+((ep.ordinal)?ep.ordinal:""))+"</p>";
            } else { // We want to show (Season# episode#) in Collection episode
	            htm += "<p class='m0'>"+"Season "+ep.sOrdinal+((ep.atype=='preview')?" Preview":" Episode "+((ep.ordinal)?ep.ordinal:""))+"</p>";
            }
            
        }

        if(ep.a_desc_short) htm += "<p>"+ep.a_desc_short+"</p>";     

        if(!img && ep.status=="passport_exclusive"){ htm += "<p>Requires Passport</p>"; }
            htm += "</div>"
           return { htm:htm, hasNew:hasNew };
	}
	
	
	// Child View for Playing Episode 
	var playingEpisodeView = Mn.View.extend({
		className: "page_episode py8"
		,getTemplate: function(){
				var tmpl = "#tmpl-shows-episode";
				if(this.attributes.program.attributes.slug==='curate'
			       || this.attributes.program.attributes.slug==='curate-u'
			       || this.attributes.program.attributes.slug==='curate-757'){
				     tmpl = "#tmpl-show-curate-episode";
			    }
			    return tmpl;
			}
		,templateContext:function(){
			var preferredAsset, title;
			preferredAsset = _.findWhere(this.model.attributes.assets, { type: "full_length"});
			if(!preferredAsset){ preferredAsset = _.findWhere(this.model.attributes.assets, {type:'preview'}) }
            if(!preferredAsset){ preferredAsset = assets[0]; }
            
	        var duration = Backbone.Radio.channel('time').request('formatDuration',preferredAsset.duration*1000)
	            if(duration && this.model.attributes.seasonid){ duration = "<span class='mx6 light-gray'>|</span>"+duration; }

			var playlist = "";
            if(this.model.attributes.assets[0].playlist){
	            var plJSON = JSON.parse(this.model.attributes.assets[0].playlist)
		           
		        _.each(plJSON, function(p){
			    	playlist += "<div style='border-bottom:3px solid #444'>"
			    	if(p.time) playlist += p.time+"<br>";
			    	if(p.song) playlist += "Song: "+p.song+"<br>";
			    	if(p.artist) playlist += "Artist: "+p.artist+"<br>";
			    	if(p.album) playlist += "Album: "+p.album+"<br>";
			    	if(p.composer) playlist += "Composer: "+p.composer;
			    	playlist += "</div>"    
				})
			}
			
            return {
		        preferredAsset:preferredAsset
		        ,duration:duration
		        ,signedIn:Backbone.Radio.channel('account').request('isSignedIn')
		        ,poster:Backbone.Radio.channel('utilities').request('image-parse',{json:preferredAsset.images,desiredProfile:"asset-mezzanine-16x9"})
		        ,showTitle:this.attributes.program.attributes.title
		        ,showSlug:this.attributes.program.attributes.slug
	        }
			
		}
		,onAttach: function(){
		  	var that = this; 
		    var assets = this.model.attributes.assets;
		    /* If there is only one result, it's an object, so make it an array */
		    if(!Array.isArray(assets)){ assets[0] = assets}
		   
		    var preferredAsset;
			preferredAsset = _.findWhere(assets, { type: "full_length"});
			if(!preferredAsset){ preferredAsset = _.findWhere(assets, {type:'preview'}) }
		    if(!preferredAsset){ preferredAsset = assets[0]; }
		    	
		    // We need to add $auth_cookie['pbsid'] to iframe source to prevent double signin through PBS 				player code. PT#174230448 
		    var pbs_player_code;
			var uid = Backbone.Radio.channel('account').request('uid');	
			if(uid){		
				var pbs_player_code = preferredAsset.player_code.split(" ").map(function(each){
					if(each.startsWith("src")){
						return "src='"+each.split("'")[1]+"&uid="+uid+"'";
					} else {
						return each;
					}	
				})
				pbs_player_code = pbs_player_code.join(" ");
			} else {
				pbs_player_code = preferredAsset.player_code;
			}
		     //is Public, or is Passport and you're logged in
			if(+preferredAsset.is_public || (Backbone.Radio.channel('account').request('isSignedIn') && +preferredAsset.is_passport) ){
				$("#pbsPartnerPlayer").html(pbs_player_code);
				$("#partnerPlayer").css({
					position: "absolute", top: 0, left: 0
				})
	        }

			//SeasonEpInfo
			if(this.model.attributes.seasonid){
		        $.when( Backbone.Radio.channel('entities').request('season',{id:this.model.attributes.seasonid}) ).done(function(data){ 
			        var htm = "";
			        if(data.attributes.ordinal){ htm += "Season "+data.attributes.ordinal+" "; }
			        if(that.model.attributes.ordinal){ htm += "Episode "+that.model.attributes.ordinal; }
			        if(preferredAsset.type==="preview"){ htm += " Preview" }
			        //if(htm){ htm += " | "}
			        that.$el.find('.seasonEpInfo').html(htm)
			        
			        /* Custom for Curate */
			        if(that.attributes.program.attributes.slug==='curate' 
	        			|| that.attributes.program.attributes.slug==='curate-u'
	        			||that.attributes.program.attributes.slug==='curate-757'){
								$('#curate_artists').data('season_ordinal',data.attributes.ordinal)
								$.getScript({ url:"/assets/js/custom/curate/"+that.attributes.program.attributes.slug+".js" })
					}
				})
			}
			
			/* 
	           Google Ads 
	         */
            Backbone.Radio.channel('ads').trigger('show','tv')    		    
	    } 
	});
	

	
	return new (tvEpisodeView)();
});